import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import { StatusBox, StatusBoxWithCheckmark } from 'components';
import './styles/Information.scss';
import { CONST_RETAIL_APPLICANT } from 'shared/constants';

interface Props {
  handleChangeAgreementsStatus,
  handleChangeAdminStatus,
  labelTransID?:string,
  agreements?:any,
  isSign?:boolean,
  // assetAllocationAvailable?:boolean,
  isCRNsaved?:boolean,
  isCustomCrn?:boolean,
  isDisabled?: boolean,
}

const Qualified: React.FC<Props> = memo((props) => {
  const {
    agreements: {
      agreements,
      signedStatus,
      adminStatus,
    }, isSign,
    handleChangeAgreementsStatus = () => {},
    labelTransID,
    isCRNsaved,
    isCustomCrn = false,
    isDisabled,
  } = props;
  // console.log('123', signedStatus);

  const {
    STATUS: {
      APPROVED, UNDER_REVIEW,
    },

  } = CONST_RETAIL_APPLICANT;

  let adStatus = adminStatus && adminStatus.status;
  if (adStatus === UNDER_REVIEW) {
    adStatus = null; // TODO check this when the flow is finished or ask backend to change
    // adStatus = APPROVED;
  }

  // && agreements.status === AGREEMENT_READY;
  return (
    <div className="formsApp__content__list">

      <div className="formsApp__content__list__item">
        <StatusBoxWithCheckmark status={agreements && agreements.status} />
      </div>

      {/*  Admin Status : Retail */}
      {agreements && (isCRNsaved || !isCustomCrn) && (
      <div className="formsApp__content__list__item isChild">
        <StatusBox
          status={adStatus}
          onStatusChange={handleChangeAgreementsStatus}
          isDropdown
          isShowDate
          isDisabled={isDisabled}
          isAprroved={adStatus === APPROVED}
          // statusDetail={adminStatus && adminStatus.statusDetails}
          statusDetail={adminStatus && adStatus === APPROVED ? (
            <FormattedMessage
              key={labelTransID}
              id={labelTransID}
              values={{
                b: (...chunks) => <b>{chunks}</b>,
                date: moment(adminStatus && adminStatus.statusDetails).format('DD MMM YYYY'),
              }}
            />
          ) : null}
        />
      </div>
      )}

      {/* Signed status */}
      {agreements && (isCRNsaved || !isCustomCrn) && adminStatus && adStatus === APPROVED && (adminStatus.status === APPROVED || adminStatus.status === UNDER_REVIEW)
      && (
      <div className="formsApp__content__list__item isChild ">
        <StatusBoxWithCheckmark
          isWaiting={!isSign}
          status={signedStatus ? signedStatus.status : null}
          statusDetail={signedStatus && signedStatus.statusDetail ? (
            <FormattedMessage
              key="showAgreements01"
              id="manageApplication.signedByClientOn"
              values={{
                span: (...chunks) => <span>{chunks}</span>,
                b: (...chunks) => <b>{chunks}</b>,
                date: moment(signedStatus.statusDetail).format('DD MMM YYYY'),
              }}
            />
          ) : null}
        />
      </div>
      )}

    </div>
  );
});

export default Qualified;
